export const BILINGUAL_TASK_COLUMNS = [
  "question_pl",
  "instruction_pl",
  "answers_pl",
  "table_data_pl",
  "multi_table_data_pl",
  "matching_data_pl",
  "strikethrough_text_pl",
  "prefilled_answer_pl",
  "verdict_options_pl",
  "sources_pl",
] as const;

const BASE_TASK_COLUMNS = [
  "id",
  "slug",
  "question",
  "instruction",
  "sources",
  "answers",
  "correct_index",
  "category",
  "categories",
  "year",
  "document_type",
  "formula",
  "task_number",
  "subpoint",
  "task_type",
  "task_subtype",
  "use_yes_no",
  "model_answer",
  "prefilled_answer",
  "operational_verb",
  "table_data",
  "matching_data",
  "strikethrough_text",
  "created_at",
  "image_urls",
  "image_url",
  "image_compressed",
  "image_thumbnails",
  "image_normalized_urls",
  "is_two_points",
  "max_points",
  "is_multi_select",
  "table_scoring_mode",
  "custom_scoring_scenarios",
  "verdict_options",
  "multi_table_data",
  "is_premium",
  "instruction_image_url",
  "instruction_image_thumbnail",
  "instruction_image_normalized_url",
  "image_dimensions",
  "instruction_image_width",
  "instruction_image_height",
  "image_blur_data",
  "instruction_image_blur",
] as const;

export const TASK_SELECT_COLUMNS = [
  ...BASE_TASK_COLUMNS,
  ...BILINGUAL_TASK_COLUMNS,
].join(", ");